import { getActivePinia } from 'pinia';
import { useClientStore } from '@/store/clientStore';
import { useClientPortalStore } from '@/store/clientPortalStore';
import { useGroupMembershipStore } from '@/store/groupMembershipStore.js';
import { useGroupsStore } from '@/store/groupStore.ts';
import { useMatchesStore } from '@/store/matchesStore.ts';
import { useMatchReportStore } from '@/store/matchReportStore.ts';
import { useUploadSettingsStore } from '@/store/uploadSettingsStore.js';
import { useUserSettingsStore } from '@/store/userSettingsStore';
import { useUsersStore } from '@/store/usersStore';
import { useOfficialRankingStore } from '@/store/officialRankingStore.ts';
import { useAuthStore } from '@/store/authStore';
import { useMatchRequestStore } from '@/store/matchRequestStore.ts';
import { useMatchFeesStore } from '@/store/MatchFeesStore';
import { useGroupSignupStore } from '@/store/groupSignupStore.js';
import { useAvailabilityStore } from '@/store/availabilityStore';
import { useLearningCenterStore } from '@/store/learningCenterStore.js';
import { useFileUploadStore } from '@/store/fileUploadStore.js';
import { useSupportTicketStore } from '@/store/supportTicketStore';
import { useTicketCategoryStore } from '@/store/ticketCategoryStore.js';
import { useDurationsStore } from '@/store/durationStore.ts';
import { useUspsStore } from '@/store/uspsStore.js';
import { useGroupRequestStore } from '@/store/groupRequestStore.js';
import { useLocationStore } from '@/store/locationStore';
import { useFieldStore } from '@/store/fieldStore.js';
import { useComplexMapStore } from '@/store/complexMapStore.js';
import { useSupportDocsStore } from '@/store/supportDocStore.ts';
import { useGroupSettingStore } from '@/store/groupSettingStore.ts';
import { usePatternsStore } from '@/store/patternsStore.ts';
import { useSiteEmailStore } from '@/store/siteEmailStore.ts';
import { useSiteBroadcastStore } from '@/store/siteBroadcastStore.js';

let _pinia = null;

export function initStores(pinia) {
	_pinia = pinia;
}

function requirePinia() {
	return _pinia || getActivePinia();
}

export const stores = {
	get authStore() {
		return useAuthStore(requirePinia());
	},
	get clientStore() {
		return useClientStore(requirePinia());
	},
	get clientPortalStore() {
		return useClientPortalStore(requirePinia());
	},
	get groupMembershipStore() {
		return useGroupMembershipStore(requirePinia());
	},
	get groupStore() {
		return useGroupsStore(requirePinia());
	},
	get matchStore() {
		return useMatchesStore(requirePinia());
	},
	get matchReportStore() {
		return useMatchReportStore(requirePinia());
	},
	get uploadSettingsStore() {
		return useUploadSettingsStore(requirePinia());
	},
	get userSettingsStore() {
		return useUserSettingsStore(requirePinia());
	},
	get usersStore() {
		return useUsersStore(requirePinia());
	},
	get officialRankingsStore() {
		return useOfficialRankingStore(requirePinia());
	},
	get matchRequestStore() {
		return useMatchRequestStore(requirePinia());
	},
	get matchFeesStore() {
		return useMatchFeesStore(requirePinia());
	},
	get groupSignupStore() {
		return useGroupSignupStore(requirePinia());
	},
	get availabilityStore() {
		return useAvailabilityStore(requirePinia());
	},
	get learningCenterStore() {
		return useLearningCenterStore(requirePinia());
	},
	get fileUploadStore() {
		return useFileUploadStore(requirePinia());
	},
	get supportTicketStore() {
		return useSupportTicketStore(requirePinia());
	},
	get ticketCategoryStore() {
		return useTicketCategoryStore(requirePinia());
	},
	get durationsStore() {
		return useDurationsStore(requirePinia());
	},
	get uspsStore() {
		return useUspsStore(requirePinia());
	},
	get groupRequestStore() {
		return useGroupRequestStore(requirePinia());
	},
	get locationStore() {
		return useLocationStore(requirePinia());
	},
	get fieldStore() {
		return useFieldStore(requirePinia());
	},
	get complexMapStore() {
		return useComplexMapStore(requirePinia());
	},
	get supportDocStore() {
		return useSupportDocsStore(requirePinia());
	},
	get groupSettingStore() {
		return useGroupSettingStore(requirePinia());
	},
	get patternsStore() {
		return usePatternsStore(requirePinia());
	},
	get siteEmailStore() {
		return useSiteEmailStore(requirePinia());
	},
	get siteBroadcastStore() {
		return useSiteBroadcastStore(requirePinia());
	}
};

export const getClientStore = () => useClientStore();
export const getClientPortalStore = () => useClientPortalStore();
export const getGroupMembershipStore = () => useGroupMembershipStore();
export const getGroupStore = () => useGroupsStore();
export const getMatchStore = () => useMatchesStore();
export const getMatchReportStore = () => useMatchReportStore();
export const getUploadSettingsStore = () => useUploadSettingsStore();
export const getUserSettingsStore = () => useUserSettingsStore();
export const getUsersStore = () => useUsersStore();
export const getOfficialRankingStore = () => useOfficialRankingStore();
export const getMatchRequestStore = () => useMatchRequestStore();
export const getMatchFeesStore = () => useMatchFeesStore();
export const getLedgerStore = () => useLedgerStore();
export const getPaymentStore = () => usePaymentStore();
export const getFinanceWorkflowStore = () => useFinanceWorkflowStore();
export const getGroupSignupStore = () => useGroupSignupStore();
export const getAvailabilityStore = () => useAvailabilityStore();
export const getLearningCenterStore = () => useLearningCenterStore();
export const getFileUploadStore = () => useFileUploadStore();
export const getSupportTicketStore = () => useSupportTicketStore();
export const getTicketCategoryStore = () => useTicketCategoryStore();
export const getDurationsStore = () => useDurationsStore();
export const getUspsStore = () => useUspsStore();
export const getGroupRequestStore = () => useGroupRequestStore();
export const getLocationStore = () => useLocationStore();
export const getFieldStore = () => useFieldStore();
export const getComplexMapStore = () => useComplexMapStore();
export const getPaymentsConnectStore = () => usePaymentsConnectStore();
export const getInvoicingStore = () => useInvoicingStore();
export const getSupportDocsStore = () => useSupportDocsStore();
export const getGroupSettingStore = () => useGroupSettingStore();
export const getPatternsStore = () => usePatternsStore();
export const getSiteEmailStore = () => useSiteEmailStore();
export const getSiteBroadCastStore = () => useSiteBroadcastStore();
